<template>
    <div class="subscription-ad">
        <a
                href="#!"
                class="alert"
                @click.prevent="subscribeHandler"
        >
            <!--
                <div class="icon">

                </div>
                <div class="message">
                    {{$t('video_watch.trailer.subscription_required')}}
                </div>
            -->
            <img
                    src="/img/banners/membership_required.jpg"
                    class="image"
                    alt="Promotional banner"
            />
            <img
                    src="/img/banners/membership_required_responsive.jpg"
                    class="responsive-image"
                    alt="Promotional banner"
            />
        </a>


    </div>
</template>
<script>
    import Spinner from "./Spinner";
    import resources from '../resources';
    import EventBus from '../eventbus';

    export default {
        components: {
            Spinner,
        },
        props: {

        },
        data(){
            return {

            }
        },
        methods: {
            subscribeHandler(){
                this.$router.push({name: 'subscribe'});
            }
        },
        mounted() {
        }
    }
</script>
<style scoped lang="scss">
    @import '../styles/variables';

    .alert{
        display: flex;
        //background-color: lightgrey;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1em;
        //padding: .3em .3em .3em 0;

        .icon{
            flex-basis: 1em;
            font-size: 2.5em;
            width: 1em;
            margin: 0 .3em;
            color: $pallete_main_color;
        }

        .message{
            flex-grow: 1;
            line-height: 1.5em;
            text-align: left;

        }
    }

    .subscription-ad{

        background-color: #000000;
        color: #ffffff;

        img{
            width: 100%;
            height: auto;
        }

        .image{
            display: block;
        }

        .responsive-image{
            display: none;
        }

        @media(max-width: 768px){
            .image{
                display: none;
            }

            .responsive-image{
                display: block;
            }
        }
    }
</style>